let current = null;
/** Installs (or, with `null`, removes) the app-wide authentication. */
export function configureAuth(config) {
    current = config;
}
/** The authentication installed by {@link configureAuth}, if any. */
export function getAuthConfig() {
    return current;
}
/** Query string (without `?`) authenticating a WebSocket or new-tab URL:
 *  the configured {@link AuthConfig}, else `ggo_token=<fallbackToken>`. */
export function authQueryString(fallbackToken) {
    const params = current
        ? current.queryParams()
        : { ggo_token: fallbackToken };
    return new URLSearchParams(params).toString();
}
//# sourceMappingURL=auth-config.js.map